// Assembles the widget hook placements declared by each @esm-tools
// stac-browser-*-widget package. See docs/widgets.md in the STAC Browser
// repository for the hook/config contract itself.
import { defineAsyncComponent } from 'vue';
import { widgetEntry as namelistWidgetEntry, NamelistParameters } from '@esm-tools/stac-browser-namelist-widget';
// stac-browser-vcs-widget and stac-browser-storage-widget have no Vue
// component today (pure stac-fields registrations, see fields.config.js) --
// nothing to place here for them yet.

export default {
  [namelistWidgetEntry.hook]: [
    {
      id: namelistWidgetEntry.id,
      component: defineAsyncComponent(() => Promise.resolve(NamelistParameters)),
      condition: namelistWidgetEntry.condition,
      props: namelistWidgetEntry.props,
    },
  ],
};
